// consts.ts
export interface BlogCard {
  id: number;
  blogId: string;
  img: string;
  title: string;
  description: string;
  buttonText: string;
}

export const BLOGS_DATA: BlogCard[] = [
  {
    id: 1,
    blogId: "check-the-safest-and-surest-way-to-check-loose-dropping-in-poultry",
    img: "/img/blogs/blog_1.png",
    title: "CHECK® - THE SAFEST AND SUREST WAY TO CHECK LOOSE DROPPING IN POULTRY",
    description:
      "Loose droppings, or diarrhoea, are among the most common and concerning issues in poultry farming. They not only affect bird comfort .....",
    buttonText: "Know More",
  },
];
